import { applyChargeSuccess, normalizeChargeResponse } from './apply-charge-success.js';
import { chargeWentThrough } from './charge-went-through.js';

export function postChargeCc(url, data, onSuccess, onError) {
    $.ajax({
        url,
        type: 'POST',
        data,
        success: function (response) {
            const normalized = normalizeChargeResponse(response);
            if (normalized && normalized.duplicate_recurring && !data.confirm_duplicate_recurring) {
                if (window.confirm(normalized.error)) {
                    postChargeCc(url, Object.assign({}, data, { confirm_duplicate_recurring: 1 }), onSuccess, onError);
                    return;
                }
                onSuccess(Object.assign({}, normalized, { success: false, error: '' }));
                return;
            }
            try {
                onSuccess(normalized);
            } catch (err) {
                console.error('postChargeCc: onSuccess threw', err);
                if (chargeWentThrough(normalized)) {
                    applyChargeSuccess(normalized);
                } else if (typeof onError === 'function') {
                    onError(err);
                }
            }
        },
        error: onError,
    });
}
